import {AgentAvatarState} from "./types/AgentAvatarState";
import {AgentAvatarReaction} from "./types/AgentAvatarReaction";
import {IAgentAvatarStateLook} from "./types/IAgentAvatarStateLook";
import {IAgentAvatarReactionLook} from "./types/IAgentAvatarReactionLook";

export class AgentAvatarLooks {

    public static STATES: Record<AgentAvatarState, IAgentAvatarStateLook> = {
        [AgentAvatarState.IDLE]: {eyes: "neutral"},
        [AgentAvatarState.LISTENING]: {eyes: "tall", gaze: "translate(-4%,1%)"},
        [AgentAvatarState.THINKING]: {eyes: "up", gaze: "translate(3%,-3.5%)"},
        [AgentAvatarState.SEARCHING]: {eyes: "focus"},
        [AgentAvatarState.WORKING]: {eyes: "focus"},
        [AgentAvatarState.WRITING]: {eyes: "focus", gaze: "translate(-2.5%,3.5%)"},
        [AgentAvatarState.WAITING]: {eyes: "up", gaze: "translate(0,-3.2%)"},
        [AgentAvatarState.NOTIFYING]: {eyes: "wide", gaze: "translate(-4%,0)", badgeColor: "#3b82f6", badgeText: "1"},
        [AgentAvatarState.BLOCKED]: {eyes: "worried", gaze: "translate(0,1%)", badgeColor: "#ffb020", badgeText: "!"},
        [AgentAvatarState.ERROR]: {eyes: "dizzy", gaze: "translate(0,1.5%)", badgeColor: "#ef4444", badgeText: "×"},
        [AgentAvatarState.DONE]: {eyes: "happy", badgeColor: "#22c55e", badgeText: "✓"},
        [AgentAvatarState.CELEBRATE]: {eyes: "star", badgeColor: "#f5b301", badgeText: "★"},
        [AgentAvatarState.SLEEPING]: {eyes: "closed"},
        [AgentAvatarState.OFFLINE]: {eyes: "closed"}
    };

    public static REACTIONS: Record<AgentAvatarReaction, IAgentAvatarReactionLook> = {
        [AgentAvatarReaction.HAPPY]: {eyes: "happy", duration: 1},
        [AgentAvatarReaction.LOVE]: {eyes: "heart", duration: 1.4, glyph: "♥", glyphColor: "#ff4d6d"},
        [AgentAvatarReaction.LAUGH]: {eyes: "laugh", duration: 1.2, glyph: "ha"},
        [AgentAvatarReaction.WINK]: {eyes: "wink", duration: 1.2},
        [AgentAvatarReaction.EXCITED]: {eyes: "star", duration: 1.4, glyph: "✦", glyphColor: "#ffd166"},
        [AgentAvatarReaction.PROUD]: {eyes: "smug", duration: 1.6},
        [AgentAvatarReaction.CURIOUS]: {eyes: "curious", duration: 1.4},
        [AgentAvatarReaction.SURPRISED]: {eyes: "wide", duration: 1, glyph: "!", glyphColor: "#ffb020"},
        [AgentAvatarReaction.CONFUSED]: {eyes: "confused", duration: 1.6, glyph: "?"},
        [AgentAvatarReaction.SUSPICIOUS]: {eyes: "suspicious", duration: 1.6},
        [AgentAvatarReaction.ANGRY]: {eyes: "angry", duration: 1, glyph: "!!", glyphColor: "#ef4444"},
        [AgentAvatarReaction.SAD]: {eyes: "sad", duration: 1.8, glyph: "…"},
        [AgentAvatarReaction.SCARED]: {eyes: "tiny", duration: 1.2, glyph: "!"},
        [AgentAvatarReaction.SHY]: {eyes: "shy", duration: 1.6, glyph: "♡", glyphColor: "#ff8fab"},
        [AgentAvatarReaction.BORED]: {eyes: "bored", duration: 2, glyph: "…"},
        [AgentAvatarReaction.SLEEPY]: {eyes: "sleepy", duration: 1.8, glyph: "z"},
        [AgentAvatarReaction.NOD]: {eyes: "happy", duration: 1.2},
        [AgentAvatarReaction.NO]: {eyes: "suspicious", duration: 1.3},
        [AgentAvatarReaction.WAVE]: {eyes: "happy", duration: 1.4}
    };
}
